export default __webpack_public_path__ + "static/media/swap_vert.738980d5.svg";